import { useAuthentication } from '@givebacks/api';
import * as Sentry from '@sentry/react';
import { useBreakPoints } from 'core';
import { AnnouncementCenter } from 'core/Packages';
import { OneToTwoLayoutTemplate, Stack, Text, Title } from 'ui';

import { MyCausesImpactCard } from '../give/MyCausesImpactCard/MyCausesImpactCard';
import { MyPersonalizedStartCard } from '../give/MyPersonalizedStartCard/MyPersonalizedStartCard';
import { HowToGiveback } from './HowToGiveback/components/HowToGivebackCards';
import { MyFavoriteCauses } from './MyFavoriteCauses/MyFavoriteCauses';
import { MyFundraisingPagesSection } from './MyFundraisingPagesSection/MyFundraisingPagesSection';

const HomeContent = () => {
  const { isSmallScreen } = useBreakPoints();
  const { isAuthenticated } = useAuthentication();

  return (
    <Stack gap={isSmallScreen ? 'lg' : 'xl'}>
      {isAuthenticated && <MyFavoriteCauses />}
      {isAuthenticated && <MyFundraisingPagesSection />}
      {isAuthenticated && (
        // Ensure any pendo errors are not thrown to the user and instead of showing a fall back, just log them to sentry
        <Sentry.ErrorBoundary>
          <AnnouncementCenter />
        </Sentry.ErrorBoundary>
      )}
      {!isAuthenticated && (
        <Stack gap={isSmallScreen ? 'md' : 'lg'}>
          <Title order={2} fz={24}>
            What is Givebacks?
          </Title>
          <Text type="body">
            Givebacks is an inclusive giving ecosystem that helps people effortlessly move more
            money to the causes they care about. No matter how big or small, everyone can and will
            make a difference when they’re a part of Givebacks.
          </Text>
        </Stack>
      )}
      <HowToGiveback />
    </Stack>
  );
};

const Home = () => {
  const { isAuthenticated } = useAuthentication();

  return (
    <OneToTwoLayoutTemplate
      showLeftSection={isAuthenticated}
      leftSection={
        <Stack gap="lg">
          <MyPersonalizedStartCard />
          <MyCausesImpactCard />
        </Stack>
      }
      rightSection={<HomeContent />}
    />
  );
};

export { Home };
